<template>
    <div class="modal">
        <div class="modal-container">
            <div class="modal-header">
                <close-icon v-on:click="closeView"></close-icon>
                <h1>Subscription Enablements</h1>
            </div>

            <div class="modal-body no-pad">
                <div class="flex h-full">
                    <div class="w-full">
                        <div class="permissions-body">
                            <ul class="list-unstyled" v-if="loaded">
                                <li v-for="(item, index) in enablementsList">
                                    <label class="block text-gray-800 text-sm mb-2">{{
                                            prettifyEnablementName(enablementsList[index].permission)
                                        }}</label>
                                    <input type="number" v-model="enablementsList[index].value"
                                           class="form-field inline">
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal-footer">
                <div class="flex">
                    <div class="right text-right">
                        <button class="btn-tertiary muted" type="button" @click="closeView">Close</button>

                        <button class="btn-primary" type="button" @click="saveForm">Save</button>
                    </div>
                </div>
            </div>
            <router-view v-slot="{ Component }">
                <transition name="drop-in" mode="in-out">
                    <component :is="Component"></component>
                </transition>
            </router-view>
        </div>
    </div>
</template>

<script>
export default {
    name: "SubscriptionEnablements",
    data() {
        return {
            enablementsList: [
                {permission: 'media-requests', value: 0},
                {permission: 'media-lists', value: 0},
                {permission: 'user-accounts', value: 0},
                {permission: 'press-releases', value: 0},
                {permission: 'profiles', value: 0},
                {permission: 'copywriting', value: 0},
                {permission: 'image-attachments', value: 0},
                {permission: 'detailed-analytics', value: 0},
                {permission: 'historical-publication', value: 0},
                {permission: 'media-database', value: 0},
            ],
            loaded: false,
        }
    },
    mounted() {
        this.setMetaTitle('Subscription Enablements | JournoLink Control')
        this.loadData()
    },
    methods: {
        loadData() {
            axios.get(route('subscriptions.enablements', this.$route.params.subscriptionId))
                .then(response => {
                    response.data.enablements.length && this.addEnablementsToList(response.data.enablements)
                    this.loaded = true
                })
                .catch(e => {
                    console.error({e})
                })
        },
        saveForm() {
            axios.post(route('subscriptions.enablements.store', {subscription: this.$route.params.subscriptionId}),
                this.enablementsList
            )
                .then(response => {
                    this.$bus.$emit('alert.success', 'Enablements have been updated')
                })
                .catch((e) => {
                    this.$bus.$emit('alert.danger', 'Enablements update failed')
                    console.error({e})
                })
        },
        /**
         * Emit the close event to the parent
         *
         * @return {void}
         */
        closeView() {
            this.setMetaTitle('View Subscription | JournoLink Control')
            this.$root.goBack()
        },
        /**
         * Handle an [Escape] keypress
         *
         * @return {void}
         */
        onEscapeKeypress() {
            this.closeView()
        },
        /**
         * Add existing enablements to the list
         *
         * @return {void}
         */
        addEnablementsToList(enablements) {
            for (let enablementsListItem of this.enablementsList) {
                let enablementFound = enablements.find(enablement => enablement.permission === enablementsListItem.permission)
                Object.assign(enablementsListItem, enablementFound)
            }
        },
        /**
         * Prettify the enablement name for display
         *
         * @param name
         * @return {String}
         */
        prettifyEnablementName(name) {
            return name.replace('-', ' ').split(' ').map((value) => {
                return value.substring(0, 1).toUpperCase() + value.substring(1)
            }).join(' ')
        },
    }
}
</script>

<style lang="less">
.permissions-body {
    width: 100%;
    padding: 15px;

    ul {
        list-style-type: none;
        margin: 0;
        padding: 0;

        li {
            padding: 5px 0;
            float: left;
            width: 50%;

            &:nth-child(2n+0) {
                clear: right;
            }
        }
    }
}
</style>
